import { useSWR } from '~/hooks/useSWR';

import { getContracts } from './data';

export const useContracts = (profileId: number) => {
  const { data, isLoading, error } = useSWR(
    ['contracts', profileId],
    () => getContracts(profileId),
    { revalidateOnFocus: false },
  );

  return {
    data: data || [],
    isLoading,
    error,
  };
};
